import "./styles.scss";
import konektavLogo from "../../assets/img/v5-konektav-suite.png";
import litePosLogo from "../../assets/img/v5-lite-pos.png";

const Icon = ({ name, size = 22 }) => {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true,
  };

  const paths = {
    arrow: (
      <>
        <path d="M5 12h14" />
        <path d="M13 6l6 6-6 6" />
      </>
    ),
    check: <path d="m5 12 4 4L19 6" />,
    cart: (
      <>
        <circle cx="9" cy="20" r="1" />
        <circle cx="19" cy="20" r="1" />
        <path d="M3 4h2l2.6 11.2A2 2 0 0 0 9.5 17H18a2 2 0 0 0 1.9-1.4L22 8H7" />
      </>
    ),
    inventory: (
      <>
        <path d="M4 7 12 3l8 4-8 4-8-4Z" />
        <path d="M4 7v10l8 4 8-4V7" />
        <path d="M12 11v10" />
      </>
    ),
    report: (
      <>
        <path d="M4 19V5a2 2 0 0 1 2-2h9l5 5v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z" />
        <path d="M14 3v6h6" />
        <path d="M8 16v-3M12 16v-6M16 16v-4" />
      </>
    ),
    users: (
      <>
        <path d="M16 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2" />
        <circle cx="9.5" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </>
    ),
    devices: (
      <>
        <rect x="3" y="4" width="13" height="16" rx="2" />
        <path d="M8 18h3" />
        <rect x="17" y="8" width="4" height="8" rx="1" />
      </>
    ),
    branch: (
      <>
        <path d="M6 3v6a3 3 0 0 0 3 3h6" />
        <path d="M18 9v6a3 3 0 0 1-3 3H9" />
        <circle cx="6" cy="3" r="2" />
        <circle cx="18" cy="9" r="2" />
        <circle cx="6" cy="18" r="2" />
      </>
    ),
    clock: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
      </>
    ),
    receipt: (
      <>
        <path d="M6 3h12v18l-2-1-2 1-2-1-2 1-2-1-2 1V3Z" />
        <path d="M9 8h6M9 12h6M9 16h4" />
      </>
    ),
    calendar: (
      <>
        <rect x="3" y="5" width="18" height="16" rx="2" />
        <path d="M16 3v4M8 3v4M3 10h18" />
      </>
    ),
  };

  return <svg {...common}>{paths[name]}</svg>;
};

const reasons = [
  ["clock", "Easy to Use", "Designed for daily operations, with simple workflows for sales, items, records, and receipt printing."],
  ["branch", "All-in-One Business Management", "Bring sales, inventory, customers, suppliers, purchases, expenses, payroll, bookings, and reports into one system."],
  ["receipt", "Fast and Reliable POS", "Help cashiers process transactions, print receipts, manage orders, and keep sales records organized."],
  ["inventory", "Better Inventory Control", "Track products, stock movement, purchases, transfers, and item availability with less manual work."],
  ["report", "Useful Reports", "Review sales, expenses, purchases, stock, and performance reports to make better decisions."],
  ["devices", "Multi-Device Support", "Connect printers, kitchen order workflows, booking stations, and cashier devices so teams stay coordinated."],
];

const suiteFeatures = [
  "Sales management",
  "Inventory management",
  "Customer records",
  "Supplier records",
  "Purchases and expenses",
  "Payroll and staff records",
  "Bookings and reservations",
  "Reports and dashboard",
  "Multi-branch or multi-location support",
  "Storefront or online selling support",
];

const posFeatures = [
  "Fast cashier sales",
  "Receipt printing",
  "Product and price lookup",
  "Order handling",
  "Kitchen order support",
  "Sales transfer support",
  "Cashier device coordination",
  "Local storage support",
  "Simple daily sales tracking",
];

const industries = [
  "Retail stores",
  "Restaurants and cafes",
  "Hotels and lodging businesses",
  "Pharmacies",
  "Groceries and convenience stores",
  "Commissaries and food production",
  "Service businesses",
  "Growing businesses with multiple branches",
];

const benefits = [
  "Save time on daily operations",
  "Reduce manual encoding",
  "Improve sales and inventory accuracy",
  "Monitor business performance better",
  "Help staff work faster",
  "Keep records organized",
  "Support business growth",
];

function ProductMockup() {
  return (
    <div className="productMockup" aria-label="KonekTaV and Lite POS software preview">
      <div className="mockupPanel erpPanel">
        <div className="mockupTop">
          <span></span>
          <b>KonekTaV Suite</b>
          <small>Live</small>
        </div>
        <div className="metricRows">
          <div><small>Sales Today</small><strong>128</strong><em>+18%</em></div>
          <div><small>Inventory Value</small><strong>4.8M</strong><em>Tracked</em></div>
          <div><small>Bookings</small><strong>36</strong><em>Active</em></div>
        </div>
        <div className="chartLine">
          <i></i><i></i><i></i><i></i><i></i><i></i>
        </div>
        <div className="moduleGrid">
          {["Sales", "Inventory", "Customers", "Payroll", "Bookings", "Reports"].map((item) => <span key={item}>{item}</span>)}
        </div>
      </div>

      <div className="posTerminal">
        <div className="terminalScreen">
          <div className="screenHead"><b>Lite POS</b><span>Cashier 01</span></div>
          <div className="saleItems">
            <span>Classic Burger <b>2</b></span>
            <span>House Coffee <b>3</b></span>
            <span>Service Fee <b>1</b></span>
          </div>
          <div className="saleTotal"><span>Total</span><strong>PHP 1,245.00</strong></div>
        </div>
        <div className="keypad">
          {Array.from({ length: 12 }).map((_, index) => <i key={index}></i>)}
        </div>
      </div>

      <div className="receiptFloat">
        <Icon name="receipt" size={24} />
        <span>Kitchen order sent</span>
      </div>
      <div className="stockFloat">
        <Icon name="inventory" size={24} />
        <span>Stock updated</span>
      </div>
    </div>
  );
}

function FeatureList({ title, logo, items, accent }) {
  return (
    <article className="featureList" style={{ "--accent": accent }}>
      <div className="featureListHead">
        <img src={logo} alt="" />
        <h3>{title}</h3>
      </div>
      <ul>
        {items.map((item) => (
          <li key={item}><Icon name="check" size={16} />{item}</li>
        ))}
      </ul>
    </article>
  );
}

export default function KonektavLitePos() {
  return (
    <main id="konektavLitePage">
      <section className="productHero">
        <div className="shell heroGrid">
          <div className="heroCopy">
            <span className="eyebrow">KonekTaV Suite and Lite POS</span>
            <div className="suiteLockup" aria-label="KonekTaV Suite and Lite POS">
              <div className="suiteLogoCard suiteLogoCard--konektav">
                <img src={konektavLogo} alt="KonekTaV Suite logo" />
              </div>
              <span className="suiteLockup__plus">+</span>
              <div className="suiteLogoCard suiteLogoCard--litepos">
                <img src={litePosLogo} alt="Lite POS logo" />
              </div>
              <div className="suiteLockup__copy">
                <strong>KonekTaV Suite + Lite POS</strong>
                <span>ERP, inventory, cashier, and daily operations in one connected setup.</span>
              </div>
            </div>
            <h1>Simple Business Software for Daily Operations</h1>
            <p>
              KonekTaV Suite and Lite POS help businesses manage sales, inventory,
              customers, bookings, reports, and daily transactions in one practical
              system.
            </p>
            <p>
              It is built for business owners who want a simple, reliable, and
              easy-to-use solution for their store, restaurant, hotel, pharmacy,
              retail shop, or service business.
            </p>
            <div className="heroActions">
              <a className="button" href="#request-demo">Request a Demo <Icon name="arrow" size={17} /></a>
              <a className="button button--outline" href="#features">View Features</a>
            </div>
          </div>
          <ProductMockup />
        </div>
      </section>

      <section className="quickSummary">
        <div className="shell summaryCard">
          <div>
            <span>Short Website Version</span>
            <p>
              KonekTaV Suite and Lite POS give your business a simple and reliable
              way to manage sales, inventory, customers, purchases, expenses,
              bookings, and reports. From cashier transactions to business
              monitoring, KonekTaV helps owners and staff work faster, reduce
              manual work, and keep operations organized.
            </p>
          </div>
          <a href="#request-demo">Start smarter operations <Icon name="arrow" size={16} /></a>
        </div>
      </section>

      <section className="whyChoose shell">
        <div className="sectionHeading">
          <span>Why Choose KonekTaV?</span>
          <h2>Practical tools for the work your team does every day.</h2>
        </div>
        <div className="reasonGrid">
          {reasons.map(([icon, title, text]) => (
            <article key={title}>
              <div><Icon name={icon} /></div>
              <h3>{title}</h3>
              <p>{text}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="featureSection" id="features">
        <div className="shell featureGrid">
          <FeatureList title="KonekTaV Suite Major Features" logo={konektavLogo} items={suiteFeatures} accent="#087c45" />
          <FeatureList title="Lite POS Major Features" logo={litePosLogo} items={posFeatures} accent="#ff7900" />
        </div>
      </section>

      <section className="businessFit shell">
        <div className="fitPanel industriesPanel">
          <div className="sectionHeading left">
            <span>Best For</span>
            <h2>Flexible for different businesses</h2>
          </div>
          <div className="pillGrid">
            {industries.map((item) => <span key={item}>{item}</span>)}
          </div>
        </div>
        <div className="fitPanel benefitsPanel">
          <div className="sectionHeading left">
            <span>Business Benefits</span>
            <h2>Better control with less manual work</h2>
          </div>
          <div className="benefitList">
            {benefits.map((item) => <span key={item}><Icon name="check" size={16} />{item}</span>)}
          </div>
        </div>
      </section>

      <section className="workflowBand" id="workflow">
        <div className="shell workflowGrid">
          {[
            ["cart", "Sell", "Process cashier sales, orders, and receipts."],
            ["inventory", "Track", "Update products, stock movement, and item availability."],
            ["calendar", "Book", "Manage reservations, service schedules, and bookings."],
            ["report", "Review", "See daily sales, stock, expenses, and business reports."],
          ].map(([icon, title, text], index) => (
            <article key={title}>
              <span>{String(index + 1).padStart(2, "0")}</span>
              <Icon name={icon} />
              <h3>{title}</h3>
              <p>{text}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="finalCta" id="request-demo">
        <div className="shell ctaInner">
          <div>
            <span>Call to Action</span>
            <h2>Start managing your business the smarter way with KonekTaV Suite and Lite POS.</h2>
            <p>Contact us today to request a demo or learn which setup is best for your business.</p>
          </div>
          <a className="button button--light" href="mailto:contact@brvtechnologysg.com">Contact Us Today <Icon name="arrow" size={16} /></a>
        </div>
      </section>
    </main>
  );
}
